import { pageIds } from './pageIds';

export const defaultPageId = pageIds.status;
